/**
 * ColorVariantMap — centralized multilingual color mapping.
 *
 * Data (single source): snippets/variant-color-map.liquid
 *   window.COLOR_LABEL_TO_CANONICAL  — displayed label → canonical Polish
 *   window.COLOR_CANONICAL_TO_ALT    — canonical Polish → media ALT
 *
 * Public API (use these everywhere):
 *   ColorVariantMap.labelToCanonical(label)
 *   ColorVariantMap.canonicalToAlt(canonical)
 *   ColorVariantMap.labelToAlt(label)  // convenience: label → canonical → ALT
 *
 * Matching is label-based, never option index/position.
 * Do not add maps in other files.
 */
(function (w) {
  'use strict';

  function normalizeColorText(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function mapLookup(map, key) {
    if (!map || typeof map !== 'object') return null;
    var k = normalizeColorText(key);
    if (!k) return null;
    if (Object.prototype.hasOwnProperty.call(map, k)) return map[k];
    return null;
  }

  /** Displayed label (PL / EN / ES / legacy) → canonical Polish */
  function labelToCanonical(label) {
    return mapLookup(w.COLOR_LABEL_TO_CANONICAL, label);
  }

  /** Canonical Polish → media ALT */
  function canonicalToAlt(canonical) {
    return mapLookup(w.COLOR_CANONICAL_TO_ALT, canonical);
  }

  /** Full pipeline: label → canonical Polish → media ALT */
  function labelToAlt(label) {
    var canonical = labelToCanonical(label);
    if (!canonical) return null;
    return canonicalToAlt(canonical);
  }

  w.ColorVariantMap = {
    normalize: normalizeColorText,
    labelToCanonical: labelToCanonical,
    canonicalToAlt: canonicalToAlt,
    labelToAlt: labelToAlt,
    /** Aliases for older call sites */
    toCanonical: labelToCanonical,
    mapVariantLabelToAlt: labelToAlt,
    get COLOR_LABEL_TO_CANONICAL() {
      return w.COLOR_LABEL_TO_CANONICAL || {};
    },
    get COLOR_CANONICAL_TO_ALT() {
      return w.COLOR_CANONICAL_TO_ALT || {};
    },
  };
})(window);
